var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"states-middle"},[_c('b-row',{staticClass:"form-title"},[_c('h3',[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('p',[_vm._v(" "+_vm._s(_vm.description)+" ")])]),_c('b-container',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }